import React from 'react';
import DockDoorNumber from './DockDoorNumber';
import DockDoorSpots from './DockDoorSpots';
import { Trailer } from '../../types';

type BuildingProps = {
	doors: number[];
	trailers: Trailer[];
	dock: string;
	spotClicked: (door: any) => void;
	trailerClicked: (trailer: Trailer) => void;
	addOpen: () => void;
	tempModal: () => void;
};

export default function BuildingRVAC2({
	doors,
	dock,
	trailers,
	spotClicked,
	trailerClicked,
	addOpen,
	tempModal,
	...props
}: BuildingProps) {
	//TODO: FIX NUMBER ISSUE LATER
	const reverseDoors = [...doors];
	const reverseDoors1 = reverseDoors.splice(0, 30);
	const reverseDoors2 = reverseDoors.splice(0, 30);
	const reverseDoors3 = reverseDoors.splice(0, 30);
	return (
		<div {...props}>
			 
			<div className="flex justify-between h-20" style={{justifyContent : "space-around", paddingRight:"3px", width: "calc(100vw - 4.75rem)",height:"7rem"  } } > 
						{reverseDoors1.map((door: any) => {
					return (
						<DockDoorSpots
							key={door.id}
							trailers={trailers}
							dock={dock}
							door={door}
							trailerClicked={(trailer) => trailerClicked(trailer)}
							spotClicked={(door) => spotClicked(door)}
							addOpen={addOpen}
							tempModal={tempModal}
						/>
					);
				})}
			</div>			
			<div className="flex justify-between h-10 border-black border-2 shadow-md" style={{justifyContent : "space-around", marginBottom:"50px" , width: "calc(100vw - 4.75rem)" }}>
						{reverseDoors1.map((door: any) => {
					return <DockDoorNumber key={door.id} door={door.name} />;
				})}
			</div>
			 
			
			<div className="flex justify-between h-20" style={{justifyContent : "space-around", paddingRight:"3px", width: "calc(100vw - 4.75rem)",height:"7rem"  } } > 
						{reverseDoors2.map((door: any) => {
					return (
						<DockDoorSpots
							key={door.id}
							trailers={trailers}
							dock={dock}
							door={door}
							trailerClicked={(trailer) => trailerClicked(trailer)}
							spotClicked={(door) => spotClicked(door)}
							addOpen={addOpen}
							tempModal={tempModal}
						/>
					);
				})}
			</div>
			<div className="flex justify-between h-10 border-black border-2 shadow-md" style={{justifyContent : "space-around" , marginBottom:"50px",width: "calc(100vw - 4.75rem)" }}>
						{reverseDoors2.map((door: any) => {
					return <DockDoorNumber key={door.id} door={door.name} />;
				})}
			</div>
			<div className="flex justify-between h-20" style={{justifyContent : "space-around", paddingRight:"3px", width: "calc(78vw - 4.75rem)",height:"7rem"  } } > 
						{reverseDoors3.map((door: any) => {
					return (
						<DockDoorSpots
							key={door.id}
							trailers={trailers}
							dock={dock}
							door={door}
							trailerClicked={(trailer) => trailerClicked(trailer)}
							spotClicked={(door) => spotClicked(door)}
							addOpen={addOpen}
							tempModal={tempModal}
						/>
					);
				})}
			</div>
			<div className="flex justify-between h-10 border-black border-2 shadow-md" style={{justifyContent : "space-around" , marginBottom:"50px", width: "calc(78vw - 4.75rem)" }}>
						{reverseDoors3.map((door: any) => {
					return <DockDoorNumber key={door.id} door={door.name} />;
				})}
			</div>
		</div>
	);
}
